import {
  Box,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Stack,
  Divider,
  Grid,
} from "@mui/material";
import { EventAvailable, Block } from "@mui/icons-material";
import moment from "moment";

const MostrarMenuSemanal = ({
  ejecutiveMenus,
  rotativeMenus,
  handleSelect,
  userSelection,
}) => {
  //Ordeno el ordel del arreglo de menus
  rotativeMenus.sort((a, b) => {
    const numA = parseInt(a.menu);
    const numB = parseInt(b.menu);
    return numA - numB;
  });

  //ESTILOS PARA LOS ROTATIVOS DEL SELECT
  const ITEM_HEIGHT = 40;
  const MAX_ITEMS_VISIBLE = 10;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * MAX_ITEMS_VISIBLE,
        width: 250,
        overflowY: "auto",
        borderRadius: 8,
        border: "1px solid #3e513b",
        backgroundColor: "#f9faf7",
      },
    },
  };

  return (
    <Grid container spacing={3} justifyContent="center">
      {ejecutiveMenus.map((dia) => {
        const fecha = dia.fecha.split("T")[0];
        const selectedMenu = userSelection[fecha]?.id_menu;
        const isFeriado = dia.feriado;

        return (
          <Grid item xs={12} md={8} key={fecha}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 3,
                border: isFeriado ? "2px dashed #e53935" : "1px solid #ddd",
                backgroundColor: isFeriado ? "#fff5f5" : "#fcfcfc",
              }}
            >
              <CardContent>
                <Stack spacing={2}>
                  {/* Header con fecha y estado */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="h6" fontWeight="bold">
                      {moment(fecha).format("dddd DD")}
                    </Typography>
                    {isFeriado ? (
                      <Box
                        color="error.main"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Block fontSize="small" />
                        <Typography variant="body2">Feriado</Typography>
                      </Box>
                    ) : (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        color="success.main"
                      >
                        <EventAvailable fontSize="small" />
                        <Typography variant="body2">Día hábil</Typography>
                      </Box>
                    )}
                  </Box>

                  {!isFeriado && (
                    <>
                      {/* Menú Ejecutivo */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              color: "#3e513b",
                              "&.Mui-checked": {
                                color: "#3e513b",
                              },
                            }}
                            checked={selectedMenu === dia.id_menu}
                            onChange={(e) =>
                              handleSelect(
                                fecha,
                                "id_menu",
                                e.target.checked ? dia.id_menu : 0
                              )
                            }
                          />
                        }
                        label={dia.menu || "Menú Ejecutivo"}
                      />

                      <Divider />

                      {/* Menú Rotativo */}
                      <Box>
                        <Typography variant="subtitle2" gutterBottom>
                          Menú Rotativo
                        </Typography>
                        <Select
                          fullWidth
                          size="small"
                          displayEmpty
                          MenuProps={MenuProps}
                          sx={{
                            color: "#3e513b",
                            fontWeight: "medium",
                            borderRadius: 2,
                            borderColor: "#3e513b",
                          }}
                          value={
                            selectedMenu && selectedMenu !== dia.id_menu
                              ? selectedMenu
                              : ""
                          }
                          onChange={(e) =>
                            handleSelect(fecha, "id_menu", e.target.value)
                          }
                        >
                          <MenuItem value="" disabled>
                            Seleccionar menú rotativo
                          </MenuItem>
                          {rotativeMenus.map((item) => (
                            <MenuItem
                              key={item.id_menu}
                              value={item.id_menu}
                              sx={{
                                whiteSpace: "normal", // <--- Permite salto de línea
                                wordBreak: "break-word", // <--- Evita overflow de palabras largas
                                fontWeight: "medium",
                                color: "#3e513b",
                                "&.Mui-selected": {
                                  backgroundColor: "#d4e8d4",
                                  color: "#2d3e2a",
                                },
                                "&:hover": {
                                  backgroundColor: "#e6f0e6",
                                },
                                borderRadius: 1,
                                mb: 0.5,
                                px: 2,
                              }}
                            >
                              {item.menu}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>

                      <Divider />

                      {/* No seleccionar */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              color: "#3e513b",
                              "&.Mui-checked": {
                                color: "#3e513b",
                              },
                            }}
                            checked={selectedMenu === 0}
                            onChange={() => handleSelect(fecha, "id_menu", 0)}
                          />
                        }
                        label="No seleccionar menú"
                      />
                    </>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default MostrarMenuSemanal;
